module.exports = __webpack_public_path__ + "img/14.db27aa99.png";